export const MENU = [
  {
    textKey: 'MENU.DASHBOARD',
    link: '/dashboard',
    icon: '',
    permissionsNeeded: [],
    subMenu: []
  },
  // {
  //   textKey: 'MENU.MAP_LIST',
  //   link: '/map/list',
  //   icon: '',
  //   permissionsNeeded: ['ADMIN_USER_READ'],
  //   subMenu: []
  // },
  // {
  //   textKey: 'MENU.MEDIA',
  //   link: null,
  //   icon: 'chevron-down',
  //   permissionsNeeded: [],
  //   subMenu: [
  //     {
  //       textKey: 'MENU.MEDIA_MANAGEMENT',
  //       link: 'admin/media',
  //       icon: '',
  //       permissionsNeeded: []
  //     }
  //   ]
  // },
  // {
  //   textKey: 'MENU.ADMIN',
  //   link: null,
  //   icon: 'chevron-down',
  //   permissionsNeeded: [],
  //   subMenu: [
  //     {
  //       textKey: 'MENU.CATEGORY_VALUE_MANAGEMENT',
  //       link: 'admin/category-values',
  //       icon: '',
  //       permissionsNeeded: []
  //     }
  //   ]
  // }
];
